import React from 'react';
import parsePhoneNumber from 'libphonenumber-js';

import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import LocalPhoneOutlinedIcon from '@mui/icons-material/LocalPhoneOutlined';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import Stack from '@mui/material/Stack';

import UtrIcon from '../../Icons/UtrIcon';
import { messageUser } from '../../../utils/helpers';
import { LinkStyledButton } from '../../Styled';

import ChatIcon from '../../../assets/icons/icon-chat-blue.svg';

const ManagerCard = ({ managers = [], isUserLoggedIn = false }) => {
    const handleOnMessageClick = (memberId, displayName) => {
        messageUser(memberId, displayName);
    };

    return managers.map(({ firstName, lastName, memberId, phone, email }) => {
        const displayName = `${firstName} ${lastName}`;
        const parsedNumber = parsePhoneNumber(phone || '');
        const phoneNumber = parsedNumber?.formatInternational();
        return (
            <Card key={memberId} sx={{ my: 2 }}>
                <CardContent>
                    <Box key={memberId} display="flex" flexDirection="row" alignItems="center" width="100%">
                        <Typography variant="body1" gutterBottom>
                            {displayName}
                        </Typography>
                    </Box>
                    <Stack spacing={1}>
                        {isUserLoggedIn && (
                            <>
                                {phoneNumber && (
                                    <Link fontSize={14} href={`tel:${phone}`}>
                                        <Box display="flex">
                                            <LocalPhoneOutlinedIcon fontSize="small" sx={{ mr: 1 }} />
                                            {phoneNumber}
                                        </Box>
                                    </Link>
                                )}
                                {email && (
                                    <Link fontSize={14} href={`mailto:${email}`}>
                                        <Box display="flex">
                                            <EmailOutlinedIcon fontSize="small" sx={{ mr: 1 }} />
                                            {email}
                                        </Box>
                                    </Link>
                                )}
                            </>
                        )}
                        <LinkStyledButton
                            onClick={() => handleOnMessageClick(memberId, displayName)}
                            startIcon={<UtrIcon style={{ marginLeft: 4 }} size="20px" icon={ChatIcon} alt={`Message ${displayName}`} />}
                        >
                            {`Message ${firstName}`}
                        </LinkStyledButton>
                    </Stack>
                </CardContent>
            </Card>
        );
    });
};

export default ManagerCard;
